import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _range from "lodash/range";
import "core-js/modules/es6.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Legal } from '@nerdwallet/currency';
import Box from '@nerdwallet/react-box';
import style from './progress-bar.module.less';

var Bar = function Bar(_ref) {
  var filledPercent = _ref.filledPercent,
      numTicks = _ref.numTicks,
      interval = _ref.interval;

  var ticksMap = _range(1, numTicks);

  return /*#__PURE__*/React.createElement("div", {
    className: style['grey-bar']
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(style['filled-bar'], _defineProperty({}, style['filled-bar-100'], filledPercent === 100)),
    style: {
      width: "".concat(filledPercent, "%")
    }
  }), ticksMap.map(function (tick) {
    return /*#__PURE__*/React.createElement("div", {
      className: style['white-tick'],
      style: {
        left: "".concat(tick * interval * 100, "%")
      },
      key: "progress-bar-tick-".concat(tick)
    });
  }));
};

var ProgressBar = function ProgressBar(_ref2) {
  var percentageComplete = _ref2.percentageComplete,
      message = _ref2.message,
      numCategories = _ref2.numCategories;
  // Make the interval for laying out white tick marks to indicate progress
  var interval = 1 / numCategories;
  return /*#__PURE__*/React.createElement(Box, {
    className: style.container,
    wide: {
      justify: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: style.positioning
  }, /*#__PURE__*/React.createElement("div", {
    role: "progressbar",
    "aria-valuenow": percentageComplete * 100,
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    "aria-valuetext": message,
    className: style['progress-bar']
  }, /*#__PURE__*/React.createElement(Bar, {
    filledPercent: percentageComplete * 100,
    numTicks: numCategories,
    interval: interval
  })), /*#__PURE__*/React.createElement(Legal, {
    size: "small",
    bold: true,
    className: style.message
  }, message, /*#__PURE__*/React.createElement("span", {
    className: style['animated-dots']
  }, "."), /*#__PURE__*/React.createElement("span", {
    className: style['animated-dots']
  }, "."), /*#__PURE__*/React.createElement("span", {
    className: style['animated-dots']
  }, "."))));
};

Bar.propTypes = {
  filledPercent: PropTypes.number.isRequired,
  numTicks: PropTypes.number.isRequired,
  interval: PropTypes.number.isRequired
};
ProgressBar.propTypes = {
  percentageComplete: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  numCategories: PropTypes.number.isRequired
};
export default ProgressBar;